<template>
    <div class="self-label">
        {{$t('account_type')}}
        <el-tooltip
          class="item"
          effect="dark"
          placement="top"
          popper-class="account-role-tips"
        >
            <div class="" :style="{width: tipsWidth}" slot="content">
              <p>1.{{$t('Account_identity_tips1')}}</p>
              <p>2.{{$t('Account_identity_tips2')}}</p>
              <p>3.{{$t('Account_identity_tips5')}}</p>
              <p>4.{{$t('Account_identity_tips6')}}</p>
            </div>
              <!--编辑器报错,实际上没有问题-->
<!--          没有该图标-->
<!--            <i class="iconfont iconshuoming explain-icon"></i>-->
            <i class="el-icon-info tips-icon"></i>
        </el-tooltip>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
  export default {
    name: 'accountRoleTips',
    computed: {
      ...mapGetters(['realMobile']),
      tipsWidth(){
        if(!this.realMobile){
          return '390px';
        }else {
          return '90%';
        }
      }
    }
  };
</script>
<style lang="scss">
.account-role-tips {
  z-index: 40099!important;
}
</style>

